import React from 'react';
import {
    Col, FormGroup, Input, Label,
    Row
} from 'reactstrap';
import {
    FL_DESCRIPTION,
    FL_GIFT, FL_INCLUDE,
    FL_INFO_WINDOW, FL_NAME, FL_PRESENTATION, FL_SCHEDULE,
    FL_SHORT_DESCRIPTION, FL_TERMS_AND_CONDS, FL_WARNING
} from "../../../components/i18n/formLabels";
import {
    PH_DESCRIPTION,
    PH_GIFT, PH_INCLUDE,
    PH_INFO_WINDOW, PH_NAME, PH_PRESENTATION, PH_SCHEDULE,
    PH_SHORT_DESCRIPTION, PH_TERMS_AND_CONDS, PH_WARNING,
} from "../../../components/i18n/placeHolders";
import {LangController} from "../../../components/tabs/langController";

const ProductLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            description: '',
            include:'',
            shortDescription:'',
            schedule:'',
            pax:'',
            extra:'',
            gift: '',
            info: '' ,
            legal: '',
        }) )
        setLangChilds(items);
    }

    const formAny = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_SHORT_DESCRIPTION }</Label>
                    <Input type="textarea"
                           name="shortDescription"
                           rows="5"
                           placeholder={ PH_SHORT_DESCRIPTION }
                           value= { child.shortDescription }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_DESCRIPTION }</Label>
                    <Input type="textarea" name="description"
                           rows="10"
                           placeholder={ PH_DESCRIPTION }
                           value= { child.description }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_GIFT }</Label>
                    <Input type="textarea"
                           name="gift"
                           rows="3"
                           placeholder={ PH_GIFT }
                           value= { child.gift }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_INFO_WINDOW }</Label>
                    <Input type="textarea"
                           name="info"
                           rows="3"
                           placeholder={ PH_INFO_WINDOW }
                           value= { child.info }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_TERMS_AND_CONDS }</Label>
                    <Input type="textarea"
                           name="legal"
                           rows="8"
                           placeholder={ PH_TERMS_AND_CONDS }
                           value= { child.legal }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const formPark = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_DESCRIPTION }</Label>
                    <Input type="textarea" name="description"
                           rows="10"
                           placeholder={ PH_DESCRIPTION }
                           value= { child.description }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const formFerry = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_SHORT_DESCRIPTION }</Label>
                    <Input type="textarea"
                           name="shortDescription"
                           rows="5"
                           placeholder={ PH_SHORT_DESCRIPTION }
                           value= { child.shortDescription }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_DESCRIPTION }</Label>
                    <Input type="textarea" name="description"
                           rows="10"
                           placeholder={ PH_DESCRIPTION }
                           value= { child.description }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_GIFT }</Label>
                    <Input type="textarea"
                           name="gift"
                           rows="3"
                           placeholder={ PH_GIFT }
                           value= { child.gift }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_INFO_WINDOW }</Label>
                    <Input type="textarea"
                           name="info"
                           rows="3"
                           placeholder={ PH_INFO_WINDOW }
                           value= { child.info }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_TERMS_AND_CONDS }</Label>
                    <Input type="textarea"
                           name="legal"
                           rows="8"
                           placeholder={ PH_TERMS_AND_CONDS }
                           value= { child.legal }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>


    const getFormulary = (child, index, disableInputs, onInputChange) => {
        switch (props.appCode) {
            case "PARK" :
                return formPark(child, index, disableInputs, onInputChange)
            default:
                return formAny(child, index, disableInputs, onInputChange);
        }
    }
    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default ProductLangs;